import { UPDATE_PAYMENT_TYPE } from './updatePaymentType';
import { UPDATE_CURRENT_STAGE } from './updateCurrentStage';
import { GET_VO_PROPOSALS_OPTIONS } from './getVOProposalsOptions';
import { UPDATE_VENDOR_OPPORTUNITY } from './updateVendorOpportunity';
import { Q_GET_DEAL_INFO_FROM_EXTERNAL_DMS } from './getDealInfoFromExternalDms';
import { UPSERT_VENDOR_OPPORTUNITY_REVENUE } from './upsertVendorOpportunityRevenue';

export const VOApi = {
  update: UPDATE_VENDOR_OPPORTUNITY,
  updateCurrentStage: UPDATE_CURRENT_STAGE,
  updatePaymentType: UPDATE_PAYMENT_TYPE,
  fetchProposalOptions: GET_VO_PROPOSALS_OPTIONS,
  getDealInfoFromExternalDms: Q_GET_DEAL_INFO_FROM_EXTERNAL_DMS,
  upsertVendorOpportunityRevenue: UPSERT_VENDOR_OPPORTUNITY_REVENUE,
};
